module.exports = __webpack_public_path__ + "img/home-vip.65aa9c85.png";